import { api } from "./api";
import { aprDrg, aprDrgKeys } from "./aprDrg";
import { auditorUsers } from "./auditorUsers";
import { auditRules } from "./auditRules";
import { audits } from "./audits";
import { auth } from "./auth";
import { batchClaimKeys, batchClaims } from "./batchClaims";
import { agentKeys, caseKeys, cases, threadKeys } from "./cases";
import { claims } from "./claims";
import { dashboard, dashboardSummaryKeys } from "./dashboard";
import { drg } from "./drg";
import { directoryKeys, fileKeys, files } from "./files";
import { insurers } from "./insurers";
import { lifecycleRoles } from "./lifecycleRoles";
import { procedureCodes } from "./procedureCodes";
import { providers } from "./providers";
import { askAutodorQueueKeys, queues } from "./queues";
import { reports } from "./reports";
import { revCodes } from "./revCodes";
import {
  ssoDomainIdentityProviderKeys,
  ssoDomainIdentityProviders,
} from "./ssoDomainIdentityProviders";
import { users } from "./users";

export const apiClient = {
  lifecycleRoles,
  api,
  audits,
  aprDrg,
  auditRules,
  auditorUsers,
  auth,
  batchClaims,
  cases,
  claims,
  dashboard,
  drg,
  files,
  insurers,
  procedureCodes,
  providers,
  queues,
  reports,
  revCodes,
  ssoDomainIdentityProviders,
  users,
};

export {
  agentKeys,
  aprDrgKeys,
  askAutodorQueueKeys,
  batchClaimKeys,
  caseKeys,
  dashboardSummaryKeys,
  directoryKeys,
  fileKeys,
  ssoDomainIdentityProviderKeys,
  threadKeys,
};
